import { call, put, takeEvery } from "redux-saga/effects"

// Ecommerce Redux States
import {
  GET_COMPANIES,
  ADD_NEW_COMPANY,
  DELETE_COMPANY,
  UPDATE_COMPANY,
} from "./actionTypes"
import {
  getCompaniesFail,
  getCompaniesSuccess,
  addCompanyFail,
  addCompanySuccess,
  updateCompanySuccess,
  updateCompanyFail,
  deleteCompanySuccess,
  deleteCompanyFail,
} from "./actions"

//Include Both Helper File with needed methods
import {
  getCompanies,
  addNewCompany,
  updateCompany,
  deleteCompany,
} from "helpers/backend_helper"

function* fetchCompanies() {
  try {
    const response = yield call(getCompanies)
    yield put(getCompaniesSuccess(response))
  } catch (error) {
    yield put(getCompaniesFail(error))
  }
}

function* onUpdateCompany({ payload }) {
  try {
    const response = yield call(updateCompany, payload)
    console.log("RESPONSE: ", response)
    yield put(updateCompanySuccess(response.data))
  } catch (error) {
    yield put(updateCompanyFail(error))
  }
}

function* onDeleteCompany({ payload }) {
  try {
    const response = yield call(deleteCompany, payload)
    console.log("response", response)
    yield put(deleteCompanySuccess(response.data))
  } catch (error) {
    console.log("error", error)
    yield put(deleteCompanyFail(error))
  }
}

function* onAddNewCompany({ payload: company }) {
  try {
    const response = yield call(addNewCompany, company)
    yield put(addCompanySuccess(response.data))
  } catch (error) {
    yield put(addCompanyFail(error))
  }
}

function* companiesSaga() {
  yield takeEvery(GET_COMPANIES, fetchCompanies)
  yield takeEvery(ADD_NEW_COMPANY, onAddNewCompany)
  yield takeEvery(UPDATE_COMPANY, onUpdateCompany)
  yield takeEvery(DELETE_COMPANY, onDeleteCompany)
}

export default companiesSaga
